import React from 'react';
import { motion } from 'framer-motion';
import PricingCardWithSubscription from '../../../components/ui/PricingCardWithSubscription';
import { authGuard } from '../../../services/authGuardService';
import { stripeService } from '../../../services/stripeService';
import { subscriptionService } from '../../../services/subscriptionService';
import { useAuth } from '../../../hooks/useAuth';
import { toast } from 'react-toastify';

interface PricingPlan {
  name: string;
  price: string;
  period: string;
  description: string;
  features: string[];
  popular?: boolean;
  cta: string;
}

const plans: PricingPlan[] = [
  {
    name: "Professional",
    price: "49€",
    period: "/mois",
    description: "La solution complète avec toutes les fonctionnalités",
    features: [
      "Menu QR Code illimité",
      "Plats illimités",
      "Gestion des réservations",
      "Gestionnaire de compte dédié",
      "Intégrations Uber Eats et Deliveroo",
      "Support 24/7",
      "Personnalisation avancée",
      "Interface mobile"
    ],
    popular: true,
    cta: "Commencer l'essai gratuit de 30 jours"
  }
];



const Pricing: React.FC = () => {
  const { userProfile } = useAuth();

  const handleTrialClick = async (plan: PricingPlan) => {
    const planType = plan.name.toLowerCase() as 'professional';
    
    authGuard.handleTrialAction(planType, async () => {
      // Rediriger vers la page de sélection d'abonnement pour l'essai
      window.location.href = `/subscription/purchase?plan=${planType}&trial=true`;
    });
  };

  const handleSubscribeClick = async (plan: PricingPlan) => {
    const planType = plan.name.toLowerCase() as 'professional';
    
    authGuard.handleSubscriptionAction(planType, async () => {
      // Rediriger vers la page de sélection d'abonnement
      window.location.href = `/subscription/purchase?plan=${planType}`;
    });
  };

  return (
    <section id="pricing" className="py-16 bg-white relative min-h-screen">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header minimaliste */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light text-gray-900 mb-4">
            Tarifs
          </h2>
          
          {/* Barre orange minimaliste */}
          <div className="w-16 h-1 bg-gradient-to-r from-orange-400 to-orange-500 mx-auto mb-4"></div>
          
          <p className="text-lg sm:text-xl text-gray-500 max-w-3xl mx-auto leading-relaxed font-light">
            Une solution simple et complète pour votre restaurant
          </p>


        </motion.div>

        {/* Pricing Card minimaliste */}
        <div className="flex justify-center max-w-2xl mx-auto mt-6">
          {plans.map((plan, index) => (
            <PricingCardWithSubscription
              key={plan.name}
              plan={plan}
              isPopular={plan.popular}
              onTrialClick={() => handleTrialClick(plan)}
              onSubscribeClick={plan.name === 'Professional' ? () => handleSubscribeClick(plan) : undefined}
              index={index}
            />
          ))}
        </div>


      </div>
    </section>
  );
};

export default Pricing;